'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureToggleBuilder = exports.FeatureToggles = exports.AvailableDeploymentLevels = exports.DeploymentLevel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _coreEs = require('@mojility/core-es6');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeploymentLevel = exports.DeploymentLevel = {
  Development: 'development',
  UAT: 'uat',
  Production: 'production'
};

var AvailableDeploymentLevels = exports.AvailableDeploymentLevels = [DeploymentLevel.Development, DeploymentLevel.UAT, DeploymentLevel.Production];

var FeatureToggles = exports.FeatureToggles = function () {
  function FeatureToggles(featureSet, deploymentLevels, currentEnvironment) {
    _classCallCheck(this, FeatureToggles);

    this.deploymentLevels = deploymentLevels;
    this.featureSet = featureSet;
    this.currentEnvironment = currentEnvironment;
  }

  _createClass(FeatureToggles, [{
    key: 'isAvailable',
    value: function isAvailable(feature) {
      if (this.deploymentLevels.indexOf(this.currentEnvironment) < 0) return false; // Unknown environment
      if (this.featureSet[feature] === undefined) return false; // Unknown feature

      if (this.deploymentLevels.indexOf(this.featureSet[feature]) >= this.deploymentLevels.indexOf(this.currentEnvironment)) return true;
    }
  }]);

  return FeatureToggles;
}();

function validateEnvironment(environment, deploymentLevels) {
  var index = deploymentLevels.indexOf(environment);
  if (index < 0) throw 'Invalid environment specified ' + environment + ' not in [' + deploymentLevels.join(',') + ']';
}

function validateDeploymentLevelsInFeatureSet(featureSet, deploymentLevels) {
  for (var feature in featureSet) {
    var environment = featureSet[feature];
    try {
      validateEnvironment(environment, deploymentLevels);
    } catch (e) {
      throw 'Invalid DeploymentLevel ' + environment + ' defined for feature ' + feature;
    }
  }
}

var FeatureToggleBuilder = exports.FeatureToggleBuilder = function () {
  function FeatureToggleBuilder() {
    _classCallCheck(this, FeatureToggleBuilder);
  }

  _createClass(FeatureToggleBuilder, null, [{
    key: 'build',
    value: function build(featureSet, deploymentLevels, currentEnvironment) {
      validateDeploymentLevelsInFeatureSet(featureSet, deploymentLevels);
      validateEnvironment(currentEnvironment, deploymentLevels);
      return new FeatureToggles(featureSet, deploymentLevels, currentEnvironment);
    }
  }, {
    key: 'buildInBrowser',
    value: function buildInBrowser(featureSet, deploymentLevels, browserDomGateway) {
      var currentEnvironment = new _coreEs.Configuration(browserDomGateway).env;
      return FeatureToggleBuilder.build(featureSet, deploymentLevels, currentEnvironment);
    }
  }]);

  return FeatureToggleBuilder;
}();